import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';

import { AnalyticsViewContext, provideAnalyticsViewContext } from '@recruitee/analytics';
import type { FullCandidate } from '@recruitee/candidate-types';
import { ShareCandidatesWithContextAnalytics } from '@recruitee/candidate-util';
import { trackByProp } from '@recruitee/common';
import type { Company } from '@recruitee/company-types';
import { TranslatePipe } from '@recruitee/i18n';
import type { CandidateShareContainer } from '@recruitee/sharing-container-types';
import {
  BoxComponent,
  ButtonComponent,
  ClipboardCopy,
  DividerComponent,
  FormFieldComponent,
  GroupComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  InputComponent,
  NewItemButtonComponent,
  TruncatePipe,
  WindowRef,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-sharing-anyone-tab',
  imports: [
    CommonModule,
    HeadingComponent,
    NewItemButtonComponent,
    TranslatePipe,
    IconComponent,
    BoxComponent,
    DividerComponent,
    GroupComponent,
    ButtonComponent,
    FormFieldComponent,
    IconButtonComponent,
    InputComponent,
    TruncatePipe,
  ],
  templateUrl: './candidate-sharing-anyone-tab.component.html',
  styleUrls: ['./candidate-sharing-anyone-tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ShareCandidatesWithContextAnalytics,
    ...provideAnalyticsViewContext(AnalyticsViewContext.CopyPublicLinkDropdown),
  ],
})
export class CandidateSharingAnyoneTabComponent {
  @Input() public candidate: FullCandidate;
  @Input() public currentCompany: Company;
  @Input() public containers: CandidateShareContainer[];

  public newLinkClick = output();
  public editContainerClick = output<CandidateShareContainer>();
  public addToExisting = output();

  public shareAgainExpanded = false;
  public inActiveShare = false;
  public trackById = trackByProp({ prop: 'id' });

  constructor(
    private cdRef: ChangeDetectorRef,
    private windowRef: WindowRef,
    private shareCandidatesAnalytics: ShareCandidatesWithContextAnalytics,
    private clipboardCopy: ClipboardCopy,
  ) {}

  public ngOnChanges() {
    this.inActiveShare = !!this.containers.find(container => container.active);
  }

  public toggleShareAgain() {
    this.shareAgainExpanded = !this.shareAgainExpanded;
    this.cdRef.detectChanges();
  }

  public handleShareUrlIconClick(container: CandidateShareContainer): void {
    const shareUrl = container.shareUrl || '';
    if (shareUrl) this.windowRef.open(shareUrl, '_blank');
  }

  public copy(element: InputComponent): void {
    if (element && element.input.nativeElement) {
      this.shareCandidatesAnalytics.trackCopyPublicLink();
      this.clipboardCopy.fromHtmlElement(element.input.nativeElement);
    }
  }
}
